import { createApi } from "@reduxjs/toolkit/query/react";
import { getBaseQuery } from "../baseQuery";

interface AccountDTO {
  id: number;
  name: string;
  code: string;
  ownerAccountId: number;
  ownerAccountName: string;
  properties: {
    allModuleAccess: boolean;
    passwordPolicyName: string;
    mfaEnabled: boolean;
    financialYearOffset: string;
    legacyFeatures: string[];
    timeZone: string;
  };
  createdAt: string;
  updatedAt: string;
  active: boolean;
}

export const accountService = createApi({
  reducerPath: "deAccountService",
  baseQuery: getBaseQuery("aiakos"),
  tagTypes: ["Account"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getAccountById: builder.query<AccountDTO, string>({
      query: (id) => `/api/accounts/${id}`,
    }),
    getAccounts: builder.query<
      Pick<AccountDTO, "id" | "name" | "active" | "properties">[],
      { active?: boolean } | void
    >({
      query: (params) => {
        const queryParams: Record<string, string> = {};
        if (params?.active !== undefined) {
          queryParams["active"] = String(params.active);
        }
        return {
          url: `/api/accounts`,
          params: queryParams,
        };
      },
      providesTags: [{ type: "Account", id: "LIST" }],
    }),
  }),
});

export const { useGetAccountByIdQuery, useGetAccountsQuery } = accountService;
